
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * ScrollToTop component scrolls the page to the top whenever
 * the route changes. It also handles page view tracking.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  
  useEffect(() => {
    // Scroll to top when route changes (instant, no animation)
    window.scrollTo({ top: 0, behavior: 'instant' });
    
    // Track page view with user info if available
    const pageTitle = document.title;
    const userId = user?.id || 'anonymous';
    
    // Page view tracking could be implemented here
    console.log(`Page viewed: ${pathname} | User: ${userId} | Title: ${pageTitle}`);
    
  }, [pathname, user]);
  
  return null;
};

export default ScrollToTop;
